import React from "react";
import { portfolioData } from "../data/portfolioData";

const Experience = () => {
  const { experience, sections } = portfolioData;

  return (
    <section id="experience" className="py-16 scroll-mt-24">
      <div className="mx-auto max-w-6xl px-4">
        <h2 className="text-3xl font-bold text-white">{sections.experienceTitle}</h2>
        <ol className="mt-8 space-y-5 border-l border-slate-700 pl-5">
          {experience.map((exp) => (
            <li key={`${exp.company}-${exp.period}`} className="relative">
              <span className="absolute -left-[1.45rem] top-2 h-3 w-3 rounded-full bg-cyan-300 shadow shadow-cyan-300/50" />
              <article className="rounded-2xl border border-slate-700/60 bg-slate-900/55 p-5">
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-cyan-300">
                  {exp.period}
                </p>
                <h3 className="mt-2 text-xl font-semibold text-white">{exp.role}</h3>
                <p className="mt-1 text-sm text-slate-300">{exp.company}</p>
              </article>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default Experience;
